// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive and centered payment message styles for success/failure pages */
.centered-success-container {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    to bottom,
    rgba(72, 49, 157, 0.2) 20%,
    rgba(72, 49, 157, 0) 100%
  );
  border-radius: 0px 0px 10px 10px;
  padding: 16px;
}
 
.paymentMessageContainerSuccess,
.paymentMessageContainer {
  background: transparent;
  border-radius: 16px;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  gap: 15px;
  line-height: 1.5;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  text-align: center;
}
 
.PaymentImage {
  width: 60%;
  max-width: 180px;
  min-width: 64px;
  height: auto;
  margin-bottom: 16px;
  object-fit: contain;
  display: block;
}
 
.paymentMessageText {
  margin-bottom: 12px;
  text-align: center;
  font-size: 1rem;
}
 
.modalButton {
  margin-top: 16px;
  width: 80px;
  min-width: 80px;
  font-size: 1rem;
  border-radius: 7px;
  padding: 10px 0;
}
 
@media (min-width: 480px) {
  .paymentMessageContainerSuccess,
  .paymentMessageContainer {
    padding: 40px 32px;
    max-width: 400px;
  }
  .PaymentImage {
    max-width: 120px;
  }
}
 
@media (min-width: 768px) {
  .centered-success-container {
    padding: 0;
  }
  .paymentMessageContainerSuccess,
  .paymentMessageContainer {
    padding: 48px 40px;
    max-width: 420px;
  }
  .PaymentImage {
    max-width: 160px;
  }
}
 
@media (min-width: 1024px) {
  .paymentMessageContainerSuccess,
  .paymentMessageContainer {
    padding: 56px 48px;
    max-width: 480px;
  }
  .PaymentImage {
    max-width: 180px;
  }
}
 
@media (max-width: 600px) {
  .PaymentImage {
    width: 80%;
    max-width: 120px;
    min-width: 48px;
  }
}
 
@media (max-width: 400px) {
  .PaymentImage {
    width: 90%;
    max-width: 80px;
    min-width: 32px;
  }
}
 
@media (min-width: 900px) {
  .PaymentImage {
    max-width: 220px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Subscription/payment.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;;GAIC;EACD,gCAAgC;EAChC,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Responsive and centered payment message styles for success/failure pages */\n.centered-success-container {\n  min-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(\n    to bottom,\n    rgba(72, 49, 157, 0.2) 20%,\n    rgba(72, 49, 157, 0) 100%\n  );\n  border-radius: 0px 0px 10px 10px;\n  padding: 16px;\n}\n \n.paymentMessageContainerSuccess,\n.paymentMessageContainer {\n  background: transparent;\n  border-radius: 16px;\n  padding: 32px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 400px;\n  width: 100%;\n  margin: 0 auto;\n  justify-content: center;\n  gap: 15px;\n  line-height: 1.5;\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  text-align: center;\n}\n \n.PaymentImage {\n  width: 60%;\n  max-width: 180px;\n  min-width: 64px;\n  height: auto;\n  margin-bottom: 16px;\n  object-fit: contain;\n  display: block;\n}\n \n.paymentMessageText {\n  margin-bottom: 12px;\n  text-align: center;\n  font-size: 1rem;\n}\n \n.modalButton {\n  margin-top: 16px;\n  width: 80px;\n  min-width: 80px;\n  font-size: 1rem;\n  border-radius: 7px;\n  padding: 10px 0;\n}\n \n@media (min-width: 480px) {\n  .paymentMessageContainerSuccess,\n  .paymentMessageContainer {\n    padding: 40px 32px;\n    max-width: 400px;\n  }\n  .PaymentImage {\n    max-width: 120px;\n  }\n}\n \n@media (min-width: 768px) {\n  .centered-success-container {\n    padding: 0;\n  }\n  .paymentMessageContainerSuccess,\n  .paymentMessageContainer {\n    padding: 48px 40px;\n    max-width: 420px;\n  }\n  .PaymentImage {\n    max-width: 160px;\n  }\n}\n \n@media (min-width: 1024px) {\n  .paymentMessageContainerSuccess,\n  .paymentMessageContainer {\n    padding: 56px 48px;\n    max-width: 480px;\n  }\n  .PaymentImage {\n    max-width: 180px;\n  }\n}\n \n@media (max-width: 600px) {\n  .PaymentImage {\n    width: 80%;\n    max-width: 120px;\n    min-width: 48px;\n  }\n}\n \n@media (max-width: 400px) {\n  .PaymentImage {\n    width: 90%;\n    max-width: 80px;\n    min-width: 32px;\n  }\n}\n \n@media (min-width: 900px) {\n  .PaymentImage {\n    max-width: 220px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
